import React from "react";
import { RefreshCw, Download } from "lucide-react";

/* ── Mock data ─────────────────────────────────── */

const SUBMISSION = {
  status: "Submitted",
  lastUpdated: "March 28, 2026  18:56 PST",
  size: "3.528 bytes",
  teamName: "Great Team",
  owner: { name: "Tobcder Lee", email: "emily@sair.foundation" },
  members: [
    { name: "Tobcder Lee",   email: "emily@sair.foundation" },
    { name: "Test123 Bro",   email: "emily@sair.foundation" },
    { name: "Test4567",      email: "emily@sair.foundation" },
    { name: "Test789010",    email: "emily@sair.foundation" },
  ],
};

/* ── Row component ─────────────────────────────── */

function Row({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <div
      className="flex min-h-[48px]"
      style={{ borderTop: "1px solid var(--brand-border-faint)" }}
    >
      {/* Left label */}
      <div className="flex items-start pt-[13px] pr-[24px] w-[50%] shrink-0">
        <span
          className="font-['Helvetica_Neue:Regular',sans-serif] text-[15px] tracking-[-0.3px]"
          style={{ color: "var(--brand-text)", opacity: 0.5 }}
        >
          {label}
        </span>
      </div>
      {/* Right value */}
      <div className="flex items-start pt-[13px] flex-1 min-w-0 flex-col gap-[6px] pb-[13px]">
        {children}
      </div>
    </div>
  );
}

/* ── Value text ────────────────────────────────── */

function Val({ children }: { children: React.ReactNode }) {
  return (
    <span
      className="font-['Helvetica_Neue:Regular',sans-serif] text-[15px] tracking-[-0.3px]"
      style={{ color: "var(--brand-text)" }}
    >
      {children}
    </span>
  );
}

/* ── Member value line ─────────────────────────── */

function MemberLine({ name, email }: { name: string; email: string }) {
  return (
    <div className="flex items-baseline gap-[6px]">
      <span
        className="font-['Helvetica_Neue:Medium',sans-serif] text-[15px] tracking-[-0.3px]"
        style={{ color: "var(--brand-text)" }}
      >
        {name}
      </span>
      <span
        className="font-['Helvetica_Neue:Regular',sans-serif] text-[13px] tracking-[-0.2px]"
        style={{ color: "var(--brand-text)", opacity: 0.45 }}
      >
        ({email})
      </span>
    </div>
  );
}

/* ── Main component ────────────────────────────── */

export function MySubmissionTab() {
  return (
    <div className="w-full">

      {/* Top bar */}
      <div className="flex items-center justify-between mb-[24px]">
        <h2
          className="font-['Helvetica_Neue:Condensed_Bold',sans-serif] text-[24px] tracking-[-0.5px] m-0"
          style={{ color: "var(--brand-text)" }}
        >
          My Submission
        </h2>
        <div className="flex items-center gap-[8px]">
          {/* Modify */}
          <button
            className="flex items-center gap-[6px] px-[12px] h-[34px] bg-transparent cursor-pointer"
            style={{ border: "1px solid rgba(59,14,39,0.14)" }}
          >
            <RefreshCw size={12} style={{ color: "var(--brand-text)", opacity: 0.6 }} />
            <span
              className="font-['Helvetica_Neue:Regular',sans-serif] text-[13px]"
              style={{ color: "var(--brand-text)", opacity: 0.6 }}
            >
              Modify
            </span>
          </button>
          {/* Download Latest */}
          <button
            className="flex items-center gap-[6px] px-[12px] h-[34px] bg-transparent cursor-pointer"
            style={{ border: "1px solid rgba(59,14,39,0.14)" }}
          >
            <Download size={12} style={{ color: "var(--brand-text)", opacity: 0.6 }} />
            <span
              className="font-['Helvetica_Neue:Regular',sans-serif] text-[13px]"
              style={{ color: "var(--brand-text)", opacity: 0.6 }}
            >
              Download Latest
            </span>
          </button>
        </div>
      </div>

      {/* Table */}
      <div
        className="w-full"
        style={{ border: "1px solid var(--brand-border-faint)" }}
      >
        <Row label="Status">
          <Val>{SUBMISSION.status}</Val>
        </Row>

        <Row label="last Updated">
          <Val>{SUBMISSION.lastUpdated}</Val>
        </Row>

        <Row label="Size">
          <Val>{SUBMISSION.size}</Val>
        </Row>

        <Row label="Team name">
          <Val>{SUBMISSION.teamName}</Val>
        </Row>

        <Row label="Owner">
          <MemberLine name={SUBMISSION.owner.name} email={SUBMISSION.owner.email} />
        </Row>

        <Row label={`Team Members (${SUBMISSION.members.length})`}>
          {SUBMISSION.members.map((m, i) => (
            <MemberLine key={i} name={m.name} email={m.email} />
          ))}
        </Row>
      </div>
    </div>
  );
}
